import { db } from '../../db/db';
import ABTest from '../../model/abTest';
import AnalyticsService from '../analytics/analyticsService';
import { AB_TESTS, TEST_CONFIG } from './abTests';

// Throw out any users that have ANY old tests set
// !!
export default class ABTestingService {
  static async initialize() {
    await this.initializeTests();
  }

  static async initializeTests() {
    if (!TEST_CONFIG.tests.length) {
      // No tests to assign!
      return;
    }

    if (!TEST_CONFIG.controlGroupAllocation) {
      throw new Error('Must have a control group!');
    }

    // Get all test values in a single bulk operation
    const testIds = Object.values(AB_TESTS);
    const existingTests = await db.abTests.bulkGet(testIds);
    const alreadyAssignedTest = existingTests.find((test) => test?.test_value);

    if (alreadyAssignedTest) {
      // The user is already assigned to a test!
      return;
    }

    let totalTestSpace = TEST_CONFIG.controlGroupAllocation;
    TEST_CONFIG.tests.forEach((testConfig) => {
      totalTestSpace += testConfig.testAllocation || 1;
    });

    const testAssignment = Math.random() * totalTestSpace;

    // The user is in the control group, so assign 0 for all tests and exit
    if (testAssignment <= TEST_CONFIG.controlGroupAllocation) {
      TEST_CONFIG.tests.forEach((testConfig) => {
        ABTestingService.setTest(testConfig.test_id, 0);
      });
      return;
    }

    let curr = TEST_CONFIG.controlGroupAllocation;

    // Assign the user to 1 specific test, and leave the rest blank (but do not set them as 0)
    for (const testConfig of TEST_CONFIG.tests) {
      curr += testConfig.testAllocation || 1;

      // The user is in this test group!
      if (testAssignment <= curr) {
        const testVariants = testConfig.variants || 1;
        let assignedTestGroup = 1;
        if (testVariants > 1) {
          const random = Math.random();
          // Make assignedTestGroup will be a random integer between 1 and testVariants
          assignedTestGroup = Math.floor(random * testVariants) + 1;
        }

        ABTestingService.setTest(testConfig.test_id, assignedTestGroup);

        // Not need to set any more tests, because the user has already been assigned this one!
        break;
      }
    }
  }

  static async setTest(test_id: string, test_group: number): Promise<string> {
    const test = await ABTestingService.getABTest(test_id);

    if (test?.test_value) {
      AnalyticsService.setTestGroup(test_id, test.test_value);
      return test.test_value;
    }

    const testGroup = `GROUP_${test_group}`; // Dynamic group name based on index

    await ABTest.create<ABTest>({
      test_id,
      test_value: testGroup,
    });

    AnalyticsService.setTestGroup(test_id, testGroup, true);

    return testGroup;
  }

  static async getABTest(test_id: string): Promise<ABTest | undefined> {
    const testValue = await ABTestingService.getTestValueQuery(test_id);
    return testValue;
  }

  static async getTestValueQuery(test_id: string): Promise<ABTest | undefined> {
    return db.abTests.get({ test_id });
  }
}
